import type { UUID } from "utils";

export const URL_PARAMS = {
  PREVIEW_ACCOUNT: "preview",
  PREVIEW_TRANSACTION: "transaction",
  CONFIGURE: "configure",
};

export const CONFIGURE_PARAM_VALUES = {
  NAMED_ACCOUNTS_NOTIFICATIONS: "named-accounts-notifications",
  VOLT_ACCOUNTS_NOTIFICATIONS: "volt-accounts-notifications",
} as const;

const BASE_URL = "/accounts";

export const PAGE_URLS = {
  home: "/",
  list: `${BASE_URL}/overview`,
  accounts: `${BASE_URL}`,
  voltAccounts: `${BASE_URL}/volt-accounts`,
  namedAccounts: `${BASE_URL}/named-accounts`,
  connect: `${BASE_URL}/connect`,
  configuration: `${BASE_URL}/configuration`,
  beneficiaries: `${BASE_URL}/beneficiaries`,
  merchantBeneficiaries: `${BASE_URL}/beneficiaries/merchant`,
  namedAccountsBeneficiaries: `${BASE_URL}/beneficiaries/named-accounts`,
  payments: `${BASE_URL}/payments`,
  namedAccountsConfigurationEdit: `${BASE_URL}/configuration?${URL_PARAMS.CONFIGURE}=${CONFIGURE_PARAM_VALUES.NAMED_ACCOUNTS_NOTIFICATIONS}`,
  voltAccountsConfigurationEdit: `${BASE_URL}/configuration?${URL_PARAMS.CONFIGURE}=${CONFIGURE_PARAM_VALUES.VOLT_ACCOUNTS_NOTIFICATIONS}`,
  details: `${BASE_URL}/overview/:id`,
  vibans: `${BASE_URL}/overview/:id/vibans`,
  virtualAccounts: `${BASE_URL}/overview/:id/virtual-accounts`,
  getLinkToAccountDetails: (id: UUID) => `${BASE_URL}/overview/${id}`,
  getLinkToAccountDetailsVibans: (id: UUID) =>
    `${BASE_URL}/overview/${id}/vibans`,
  getLinkToAccountDetailsVirtualAccounts: (id: UUID) =>
    `${BASE_URL}/overview/${id}/virtual-accounts`,
  paymentDetails: `${BASE_URL}/payments/:id`,
  getLinkToPaymentDetails: (id: UUID) => `${BASE_URL}/payments/${id}`,
  getLinkToAccountPreview: (id: UUID, params?: string) => {
    if (params) {
      return `${BASE_URL}/overview?${params}&${URL_PARAMS.PREVIEW_ACCOUNT}=${id}`;
    }

    return `${BASE_URL}/overview?${URL_PARAMS.PREVIEW_ACCOUNT}=${id}`;
  },
};
